import {
  HEX_121820,
  HEX_1D2939,
  HEX_292D38,
  HEX_CED7E2,
  HEX_DCDFE6,
  HEX_E2E8F0,
} from '@tanium/colors';
import { Background2, Border1, defineColor, Overlay4 } from '@tanium/react-theme-definition';

export const ContainerBorder = defineColor([HEX_CED7E2, HEX_121820]);

export const HeadingFill = defineColor([HEX_E2E8F0, HEX_1D2939]);
export const HeadingText = defineColor([HEX_292D38, HEX_E2E8F0]);
export const SubHeadingText = defineColor([HEX_292D38, HEX_DCDFE6]);

export const BodyFill = Background2;
export const BodyFooterDivider = Border1;

export const ModalShadow = Overlay4;
